import Gaminglibrary_01 from "../assets/images/game-01.jpg"
import Gaminglibrary_02 from "../assets/images/game-02.jpg"
import Gaminglibrary_03 from "../assets/images/game-03.jpg"


const GamingLibraryData = [
    {id:"library_item_1", image: Gaminglibrary_01,  title:"Fortnite" ,category: "Sandbox"   ,   date_added:"24/8/2043",  hours_played:"634 H 22 Mins"  ,download:"downloaded" },
    {id:"library_item_2", image: Gaminglibrary_02,  title:"Pubg"     ,category: "Stream-x"  ,   date_added:"24/8/2043",  hours_played:"740 H 52 Mins"  ,download:"download"},
    {id:"library_item_3", image: Gaminglibrary_03,  title:"Cs-Go"    ,category: "Legandary" ,   date_added:"24/8/2043",  hours_played:"892 H 14 Mins"  ,download:"downloaded" },
]
export default GamingLibraryData;






